import * as React from 'react';

import Checklist from '@src/components/Lists/CheckList';

import * as styles from './gridTwoCol.module.scss';

export interface GridTwoColProps {
  children?: React.ReactNode[] | React.ReactNode;
  border?: 'gray' | 'painted';
  gridType?: 'split' | 'wide';
  columnContent?: any;
  checklistContent?: any;
}

const GridTwoCol = ({
  children,
  border,
  gridType,
  columnContent,
  checklistContent,
}: GridTwoColProps) => {
  const randomInt = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
  columnContent = columnContent || null;
  let leftColumn = null;
  let rightColumn = null;
  let style;

  if (columnContent) {
    leftColumn = columnContent.left_column.html;
    rightColumn = columnContent.right_column.html;

    // Don't change the border or gridType if it has been passed in through the template
    if (!border) {
      border = columnContent.border_color
        ? columnContent.border_color.toLowerCase()
        : null;
    }

    if (!gridType) {
      gridType =
        columnContent.grid_type === 'Even column width' ? 'split' : 'wide';
    }
  }

  if (border === 'painted') {
    style = {
      backgroundPosition: `center ${randomInt * 10}%`,
    };
  }

  return (
    <section className={styles.wrapper}>
      <div
        className={`${styles.content} ${styles[gridType]} ${
          border ? null : styles.noBorder
        }`}>
        {border && <hr style={style} className={styles[border]} />}
        <div className="row">
          {leftColumn && (
            <div
              className="left"
              dangerouslySetInnerHTML={{__html: leftColumn}}
            />
          )}
          {rightColumn && (
            <div className="right">
              <div dangerouslySetInnerHTML={{__html: rightColumn}} />
              {checklistContent && <Checklist>{checklistContent}</Checklist>}
            </div>
          )}
        </div>
        {children}
      </div>
    </section>
  );
};

export default GridTwoCol;
